import React, { useEffect, useRef } from "react";
import { Container } from "react-bootstrap";
import { connect } from "react-redux";
import { uniqBy, } from "lodash";
import { DeleteAttendanceApi } from "./attendanceAction";
import { setHeading } from "../../../accounts/account.actions";
import { baseURL, headers } from "../../../../../global/api";
import moment from "moment";
import MaterialTable from 'material-table';


const AttendanceView = (props) => {
    const tableRef = useRef();
    function updateTableQuery() {
        tableRef.current.onQueryChange()
    };

    useEffect(() => {
        props.setHeading("Attendence List")
    }, []);

    return (
        <>
            <Container fluid>
                <MaterialTable
                    tableRef={tableRef}
                    title="Attendence List"
                    columns={uniqBy([
                        { title: 'Month Name', field: 'attendanceMonthYear', render: rowData => new Date(rowData.attendanceMonthYear + "-01").toLocaleString("default", { month: "long" }) },
                        { title: 'Attendance Month', field: 'attendanceMonthYear', editable: 'never' },
                        {
                            title: "Status", field: "attendanceStatus",
                            render: (rowData) => (
                                <div
                                    style={{
                                        backgroundColor: rowData.attendanceStatus === 'Temporary' ? "#ffc266ff" : rowData.attendanceStatus === 'Permanent' ? "#639ed9ff" : "#f7cb74",
                                        padding: "5px 16px 7px",
                                        borderRadius: "10px",
                                        textAlign: "center",
                                        width: "max-content"
                                    }}
                                >
                                    {rowData.attendanceStatus}
                                </div>
                            ),
                        },
                        { title: 'Upload Date', field: 'attendanceDate', render: rowData => moment(rowData.attendanceDate).format('DD-MM-YYYY') },
                        { title: 'Created By', field: 'userDetails.userName', editable: 'never' },
                    ], 'title')}
                    data={(query) =>
                        new Promise((resolve, reject) => {
                            let url = `${baseURL}/attendance/get-attendance?`;
                            url += "limit=" + query.pageSize;
                            url += "&page=" + query.page;
                            url += "&search=" + query.search;
                            fetch(url, {
                                method: "GET",
                                headers: headers,
                            }).then((response) => response.json()).then((result) => {
                                resolve({
                                    data: result.data,
                                    page: result.page,
                                    totalCount: result.total_results,
                                });
                            });
                        })
                    }
                    detailPanel={rowData => {
                        return (
                            <MaterialTable
                                columns={[
                                    { title: 'Employee Id', field: 'employeeId' },
                                    { title: 'Machine Id', field: 'employee_code' },
                                    { title: 'Employee Name', field: 'employeeName' },
                                    { title: 'Present Days', field: 'presentDays' },
                                    { title: 'Absent Days', field: 'absentDays' },
                                    { title: 'Total Work Hours', field: 'totalWorkHours' },
                                    { title: 'Over Time Hours', field: 'overTimeHours' },
                                    { title: 'Late Coming Hours', field: 'lateComingHours' },
                                    { title: 'Early Going Hours', field: 'earlierGoingHours' },
                                    { title: 'Casual Leaves', field: 'casualLeave' },
                                    { title: 'Sick Leaves', field: 'sickLeave' },
                                    // { title: 'Attendance Date', field: 'attendance_date' },
                                    // { title: 'Attendance in Time', field: 'attendance_in_time' },
                                    // { title: 'Attendance out Time', field: 'attendance_out_time' },
                                    // { title: 'Break in Time', field: 'break_in_time' },
                                    // { title: 'Break out Time', field: 'break_out_time' },
                                ]}
                                data={rowData.attendanceData}
                                options={{
                                    search: true,
                                    actionsColumnIndex: -1,
                                    toolbar: false,
                                    exportButton: true,
                                    sorting: true,
                                    paging: true,
                                    pageSize: 50,
                                    emptyRowsWhenPaging: false,
                                    pageSizeOptions: [50, 100, 150, 200],
                                    headerStyle: {
                                        position: 'sticky', top: 0,
                                        color: '#00BBBB',
                                        fontWeight: '550',
                                        onRowAdd: 'none',
                                    }
                                }}
                            />
                        )
                    }}
                    options={{
                        actionsColumnIndex: -1,
                        filtering: false,
                        exportButton: true,
                        exportAllData: true,
                        sorting: true,
                        paging: true,
                        pageSize: 50,
                        emptyRowsWhenPaging: false,
                        pageSizeOptions: [50, 100, 150, 200, 500],
                        headerStyle: {
                            position: 'sticky', top: 0,
                            color: '#00BBBB',
                            fontWeight: '550',
                            onRowAdd: 'none',
                        },
                    }}
                    editable={{
                        isDeletable: rowData => rowData.attendanceStatus === 'Temporary' ? true : false,
                        isEditHidden: rowData => true,
                        onRowUpdate: (newData, oldData) =>
                            new Promise((resolve) => {
                                setTimeout(() => {
                                    resolve();
                                    // props.UpdateAttendanceApi(newData, oldData, updateTableQuery)
                                }, 600);
                            }),
                        onRowDelete: (oldData) =>
                            new Promise((resolve) => {
                                setTimeout(() => {
                                    resolve();
                                    props.DeleteAttendanceApi(oldData._id, updateTableQuery)
                                }, 600);
                            }),
                    }}
                    actions={[
                        {
                            icon: 'refresh',
                            tooltip: 'Refresh Data',
                            isFreeAction: true,
                            onClick: () => tableRef.current && tableRef.current.onQueryChange(),
                        },
                    ]}
                />
            </Container>
        </>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        DeleteAttendanceApi: (attendanceID, updateTableQuery) => dispatch(DeleteAttendanceApi(attendanceID, updateTableQuery)),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(AttendanceView);